export const StatusACBA = () => {

    return <div className='container' id='statusDiv'>
        < div className='successPage' >
            <img src={require('../../assets/success.png')} alt='' />
            <h1>Շուտով կստանաք տոմսերը ձեր նշած էլ. հասցեին</h1>
            {/* <h1>Խնդրում ենք էջը չփակել</h1> */}
        </div >
    </div >
} 